import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import Model from "../../views/dashboard/models/Model";
export default class Media extends Model {
  constructor(data) {
    super();
    _defineProperty(this, "File", {
      content: null
    });
    _defineProperty(this, "MediaStatus", {
      content: Media.READY_STATUS
    });
    if (data !== null && data !== void 0 && data.file) {
      var _data$file;
      this.File.content = (_data$file = data.file) !== null && _data$file !== void 0 ? _data$file : null;
      this.setMediaWaiting();
    }
  }
  setMediaSucceeded(make_ready = false) {
    this.MediaStatus.content = Media.SUCCESS_STATUS;
    if (make_ready) setTimeout(() => {
      this.MediaStatus.content = Media.READY_STATUS;
    }, 1000);
    return this;
  }
  setMediaFailed() {
    this.MediaStatus.content = Media.FAILED_STATUS;
    return this;
  }
  setMediaWaiting() {
    this.MediaStatus.content = Media.WAITING_STATUS;
    return this;
  }
  isReady() {
    var _this$MediaStatus;
    return ((_this$MediaStatus = this.MediaStatus) === null || _this$MediaStatus === void 0 ? void 0 : _this$MediaStatus.content) === Media.READY_STATUS;
  }
  setToReady() {
    this.MediaStatus.content = Media.READY_STATUS;
    return this;
  }
  isWaiting() {
    var _this$MediaStatus2;
    return ((_this$MediaStatus2 = this.MediaStatus) === null || _this$MediaStatus2 === void 0 ? void 0 : _this$MediaStatus2.content) === Media.WAITING_STATUS;
  }
  uploadingHasSucceeded() {
    var _this$MediaStatus3;
    return ((_this$MediaStatus3 = this.MediaStatus) === null || _this$MediaStatus3 === void 0 ? void 0 : _this$MediaStatus3.content) === Media.SUCCESS_STATUS;
  }
  uploadingHasFailed() {
    var _this$MediaStatus4;
    return ((_this$MediaStatus4 = this.MediaStatus) === null || _this$MediaStatus4 === void 0 ? void 0 : _this$MediaStatus4.content) === Media.FAILED_STATUS;
  }
  isLoading() {
    var _this$MediaStatus5;
    return ((_this$MediaStatus5 = this.MediaStatus) === null || _this$MediaStatus5 === void 0 ? void 0 : _this$MediaStatus5.content) === Media.LOADING_STATUS;
  }
  startLoading() {
    this.MediaStatus.content = Media.LOADING_STATUS;
    return this;
  }
  loadingFailed() {
    this.MediaStatus.content = Media.FAILED_STATUS;
    return this;
  }
  loadingSucceeded() {
    this.MediaStatus.content = Media.SUCCESS_STATUS;
    return this;
  }
  getFile() {
    var _this$File;
    return (_this$File = this.File) === null || _this$File === void 0 ? void 0 : _this$File.content;
  }
  updateMedia(media) {
    if (!(media instanceof Media)) return media;
    Object.keys(media).forEach(key => {
      if (this[key].fieldName) this[key].content = media[key].content;
    });
    return this;
  }
  static reInstantiate(model, instance) {
    if (!(instance instanceof Media)) return model;
    Object.keys(model).forEach(key => {
      if (!instance.hasOwnProperty(key)) return;
      if (instance[key].fieldName) instance[key].content = model[key].content;
    });
    return instance;
  }
}
_defineProperty(Media, "LOADING_STATUS", 'loading');
_defineProperty(Media, "WAITING_STATUS", 'waiting');
_defineProperty(Media, "FAILED_STATUS", 'failed');
_defineProperty(Media, "SUCCESS_STATUS", 'succeeded');
_defineProperty(Media, "READY_STATUS", 'ready');
_defineProperty(Media, "S3_LOCATION_STATUS", 's3');
_defineProperty(Media, "PENDING_LOCATION_STATUS", 'pending');
_defineProperty(Media, "LOCAL_LOCATION_STATUS", 'local');
_defineProperty(Media, "CLOUDFLARE_LOCATION_STATUS", 'cloudflare');